import { WaitlistForm } from "@/components/WaitlistForm";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-[#1e293b]/50 py-24 md:py-32"
    >
      <div className="mx-auto max-w-6xl px-6">
        <div
          data-testid="hero-badge"
          className="mb-8 inline-flex items-center gap-2 rounded-full border border-[#22d3ee]/30 bg-[#22d3ee]/5 px-3 py-1 font-mono text-xs uppercase tracking-widest text-[#22d3ee]"
        >
          <span className="h-2 w-2 animate-ping rounded-full bg-[#22d3ee]"></span>
          <span>Zero Setup Cloud Machines</span>
        </div>

        <h1
          data-testid="hero-headline"
          className="mb-6 text-4xl font-bold leading-none tracking-tight text-white md:text-7xl"
        >
          <span className="rl-ln"><span>Cloud computers built</span></span>
          <span className="rl-ln"><span className="text-[#22d3ee]">for coding agents</span></span>
        </h1>

        <p
          data-testid="hero-subheadline"
          className="rl-fade-in-seq mb-10 max-w-2xl text-lg leading-relaxed text-[#94a3b8] md:text-xl"
        >
          Agents keep working while you are away. Close your laptop, pay per
          second, and wake sleeping machines on demand.
        </p>

        <div className="rl-fade-in-seq mb-16">
          <WaitlistForm buttonLabel="Get Access" testidPrefix="hero-waitlist" />
        </div>

        {/* Terminal telemetry frame */}
        <div
          data-testid="hero-terminal"
          className="rl-frame-pop rl-drift-slow relative rounded-xl border border-[#1e293b] bg-gradient-to-br from-[#111927] via-[#0d141f] to-[#070b10] p-6 font-mono text-xs text-[#94a3b8] shadow-2xl"
        >
          <div className="mb-4 flex items-center justify-between border-b border-[#1e293b]/70 pb-4">
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-full bg-[#ef4444]/60"></span>
              <span className="h-3 w-3 rounded-full bg-[#eab308]/60"></span>
              <span className="h-3 w-3 rounded-full bg-[#22c55e]/60"></span>
              <span className="ml-2 font-semibold text-[#cbd5e1]">node-nyc-09 // agent_active</span>
            </div>
            <div className="hidden font-mono text-[#22d3ee] sm:block">PAY_PER_SECOND · ACTIVE</div>
          </div>
          <div className="space-y-2">
            <div className="text-[#38bdf8]">$ runloft spawn --agent=claude-code --sandbox=isolated</div>
            <div className="text-[#64748b]">&gt; Provisioned ephemeral Linux instance in 240ms</div>
            <div className="text-[#a855f7]">&gt; Laptop closed. Syncing detached thread to cloud loft...</div>
            <div className="text-[#22c55e]">&gt; Tests passing: 48/48. Idle mode triggered: $0.00/sec when sleeping.</div>
          </div>
        </div>
      </div>
    </section>
  );
};
